import { Request } from '../../serverApi/requests/Request';
import { IGetItemsResult } from '../../serverApi/types/IGetItemsResult';
import { IPagedItemsWithTokenParams } from '../../serverApi/types/IPageWithToken';
import WebHttpClient from '../../WebHttpClient';
import { IListWithTokenFetcher } from '../IListWithTokenFetcher';
import { ListResultWithToken } from '../ListResultWithToken';

export class WebClientListWithTokenResourceFetcher<
  TResource,
  TRequestResult extends IGetItemsResult> implements IListWithTokenFetcher<TResource> {

  constructor(
    private requestType: new (params: IPagedItemsWithTokenParams) => Request<IPagedItemsWithTokenParams, TRequestResult>,
    private resultMapper: (result: TRequestResult) => TResource[]
  ) { }

  public fetchList(params: IPagedItemsWithTokenParams): Promise<ListResultWithToken<TResource>> {
    return WebHttpClient.sendRequest(new this.requestType(params))
      .then((result: TRequestResult) => {
        const nextPageToken = result.nextPageToken;
        const errors = result.errors;
        const total = result.totalCount;
        const moreItems = result.moreItems;
        return new ListResultWithToken<TResource>(this.resultMapper(result), nextPageToken, errors, total, moreItems);
      });
  }

}